import { request } from "../request";
import { BodyFormData } from "../models";

export const createFeedback = ({ body }: BodyFormData) =>
    request({
        url: "appeals",
        method: "POST",
        body,
    });
